import {TaxFaqs} from './TaxFaqs';
import {ServiceFees} from './ServiceFees';
import {MarginBorrowing} from './MarginBorrowing';
import {MarginBorrowingFaq} from './MarginBorrowingFaq';
import {CashInvestmentCenter} from './CashInvestmentCenter';
import {ClientCashRates} from './ClientCashRates';
import {ProgramBanks} from './ProgramBanks';
import {OrderRoutingReport} from './OrderRoutingReport';

// Single source for the help routes, the help nav and the footer links.
export const HELP_HOME = '/help';

export const HELP_PAGES = [
    {
        path: '/help/order-routing-report', label: 'Order Routing Report', Page: OrderRoutingReport, category: 'Disclosures',
        description: 'SEC Rule 606 disclosures, current reports and historical quarterly reports.',
    },
    {
        path: '/help/tax-faqs', label: 'Tax Center', Page: TaxFaqs, category: 'Taxes',
        description: 'Answers to common questions about tax forms, reporting and cost basis.',
    },
    {
        path: '/help/service-fees', label: 'Service Fees', Page: ServiceFees, category: 'Account information',
        description: 'Charges for transfers, account services and other transactions.',
    },
    {
        path: '/help/margin-borrowing', label: 'Margin Borrowing', Page: MarginBorrowing, category: 'Account information',
        description: 'Eligibility, risks and published borrowing rates.',
    },
    {
        path: '/help/margin-borrowing-faq', label: 'Margin Borrowing FAQ', Page: MarginBorrowingFaq, category: 'Account information',
        description: 'Questions about margin eligibility, interest, repayments and margin calls.',
    },
    {
        path: '/help/cash-investment-center', label: 'Cash Management', title: 'Cash Management Center',
        Page: CashInvestmentCenter, category: 'Cash management',
        description: 'Cash Sweep, DP CASH and DP CASH PLUS options and how to use them.',
    },
    {
        path: '/help/cash-investment-center/rates-and-tiers', label: 'Client Cash Rates and Tiers',
        title: 'Cash Management Center: Rates and Tiers', Page: ClientCashRates, category: 'Cash management',
        description: 'Client cash rates and the terms for earning interest on each deposit option.',
    },
    {
        path: '/help/program-banks', label: 'Program Banks', title: 'Cash Management Center: Program Banks',
        Page: ProgramBanks, category: 'Cash management',
        description: 'Banks participating in the Cash Sweep Program.',
    },
];

export const HELP_CATEGORIES = [...new Set(HELP_PAGES.map(page => page.category))];
